import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MerakisService } from '@app/features/merakis/shared/merakis.service';

@Component({
    selector: 'app-meraki-switch-form',
    templateUrl: './switch-form.component.html',
    styleUrls: ['./switch-form.component.css'],
    standalone: false
})
export class MerakiSwitchFormComponent implements OnInit, OnDestroy {
    isLoading: boolean = false;
    switchForm: UntypedFormGroup;

    constructor(private merakiService: MerakisService) {}
    ngOnInit() {
        this.isLoading = true;
        this.switchForm = new UntypedFormGroup(
            {
                "serial": new UntypedFormControl(null, [
                    Validators.required,
                    Validators.minLength(14),
                    Validators.maxLength(14)
                ])
            }
        );
        this.isLoading = false;
    }
    ngOnDestroy() {}

    claimSwitch(networkId: string) {
        this.isLoading = true;
        const promise = new Promise((resolve, reject) => {
            this.merakiService.claimSwitch(
                networkId,
                this.switchForm.get('serial').value
            ).then(response => {
                response.toPromise().then(() => {
                    resolve(true);
                    this.isLoading = false;
                });
            });
        });

        return promise;
    }
}